import validate from "/codebuild/output/src3082375315/src/codestar-connections.us-east-1.amazonaws.com/git-http/867915409343/us-east-1/9e561835-8a2f-4d1c-9907-8c0e7ae28d0b/geekcafe/geek-cafe-web-site/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/codebuild/output/src3082375315/src/codestar-connections.us-east-1.amazonaws.com/git-http/867915409343/us-east-1/9e561835-8a2f-4d1c-9907-8c0e7ae28d0b/geekcafe/geek-cafe-web-site/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}